// CashDepositHeader.jsx

import React from "react";
import { ReactComponent as BackIcon } from "assets/img/svg/BackArrow.svg";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import CustomChip from "views/pages/manage/common/customChip/CustomChip";
import { HEADER_CHIPS_CONFIG } from "./constant";
import { getHeaderChipInfo } from "./constant";
import styles from "../../paymentManagement.module.scss";
import { Card, CardBody, Col, Row } from 'reactstrap'

const CashDepositHeader = ({ referenceNo, details }) => {
    return (
        <Card style={{ marginTop: "-14px" }}>
            <div className={styles['cashDepositHeader']}>
                {/* Header row */}
                <div className={styles['headerTitle']}>
                    <IconButtonWrapper onClick={() => window.close()}>
                        <BackIcon />
                    </IconButtonWrapper>
                    <span className={styles['referenceText']}>{referenceNo}</span>
                </div>

                {/* Chips */}
                <div className={styles['headerChips']}>
                    {HEADER_CHIPS_CONFIG.map(({ key, label, chipType }) => (
                        <CustomChip
                            key={key}
                            className={styles['headerChip']}
                            {...getHeaderChipInfo({
                                label,
                                value: details?.[key],
                                chipType,
                                styles
                            })}
                        />
                    ))}
                </div>
            </div>
        </Card>
    );
};

export default CashDepositHeader;
